/**
 * Page de scan (`/scan/:id`, téléphone relié par le QR projeté, ou lien
 * « Ouvrir ce lien ici » dans le navigateur du prof) : chaque requête vers le
 * serveur porte `X-Pilotage-Scan: 1`. C'est ce qui lui dit de lire le COOKIE
 * DE SCAN avant le JWT : dans le navigateur du prof les deux cookies sont
 * présents, et un JWT périmé lu en premier répondait 401 token_not_valid alors
 * que le cookie de scan était valable (bug de démo du 2026-09-12). Contrat
 * back du même jour.
 */
export const EN_TETE_PILOTAGE_SCAN = 'X-Pilotage-Scan';

export const surPageScan = () => typeof window !== 'undefined' && window.location.pathname.startsWith('/scan/');

/** Les en-têtes à ajouter à une requête partie d'une page de scan (sinon rien). */
export const enTetesPilotageScan = () => (surPageScan() ? { [EN_TETE_PILOTAGE_SCAN]: '1' } : {});
